import {
  Breadcrumb,
  ClipboardDocumentListIcon,
  ErrorAlert,
  PageHero,
  SearchToggle,
  TableRowsPerPage,
} from "@";
import MultiSearch from "./components/MultiSearch";
import { useLogsPage } from "./hooks/useLogsPage";
import { DataTable } from "@/shared/components/tanstackTable";

const Index = () => {
  const {
    data,
    columns,
    isLoading,
    error,
    totalItems,
    search,
    updateSearch,
    applySearch,
    resetSearch,
    pg,
    updatePg,
    refetch,
  } = useLogsPage();

  return (
    <>
      <ErrorAlert reload={refetch} show={error} />
      <Breadcrumb links={[{ name: "السجل", link: "" }]} />

      <main className="table-card relative">
        <PageHero
          eyebrow="الإعدادات / السجلات"
          title="سجل الاحداث"
          count={totalItems}
          icon={ClipboardDocumentListIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={{ ...pg, rows: totalItems }}
            rowsPerPageOptions={[5, 10, 15, 25, 100, 200]}
            onRowsPerPageChange={(size) => updatePg({ size, page: 1 })}
          />

          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={applySearch}
          dataLength={data?.length}
          updateSearch={updateSearch}
          onReset={resetSearch}
        />

        <DataTable
          data={data}
          columns={columns}
          isLoading={isLoading}
          pagination={{ ...pg, rows: totalItems }}
          onPageChange={(page) => updatePg({ page })}
          onPageSizeChange={(size) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default Index;
